const createPaymentInstrument = async ({basket, authResponse, addPaymentInstrumentToBasket}) => {
    if (!basket) throw new Error('Basket is required to add a payment instrument.')

    try {
        await addPaymentInstrumentToBasket({
            parameters: {basketId: basket.basketId},
            body: {
                paymentMethodId: 'PAYPAL',
                amount: parseFloat(authResponse?.amount?.value || '0'),
                c_paypalOrderID: basket?.c_paypalOrderID,
                c_paypalOrderAuthorizedID: basket?.c_paypalOrderAuthorizedID
            }
        })
    } catch (error) {
        console.error('Error adding payment instrument:', error)
        throw error
    }
}

const paypalPaymentSubmit = async (props) => {
    const {
        resp,
        basket,
        updateBasket,
        addPaymentInstrumentToBasket,
        removePaymentInstrumentFromBasket,
        updateCustomerForBasket,
        updateShippingAddressForShipment,
        updateBillingAddressForBasket,
        onBillingSubmit,
        isExpressPaypal,
        setPaypalButtonClicked,
        navigate,
        setPayPalPurchaseStatus
    } = props
    const purchaseUnits =
        resp.status === 'COMPLETED' ? resp.purchase_units.length && resp.purchase_units[0] : ''
    const authResponse =
        (purchaseUnits &&
            purchaseUnits.payments.authorizations.length &&
            purchaseUnits.payments.authorizations[0]) ||
        {}

    try {
        isExpressPaypal && setPayPalPurchaseStatus && setPayPalPurchaseStatus(true)
        const paypalPaymentInstrument = basket?.paymentInstruments?.find(
            (pi) => pi.paymentMethodId === 'PAYPAL'
        )
        if (paypalPaymentInstrument && basket?.c_paypalOrderAuthorizedID !== authResponse?.id) {
            removePaymentInstrumentFromBasket({
                parameters: {
                    basketId: basket.basketId,
                    paymentInstrumentId: paypalPaymentInstrument.paymentInstrumentId
                }
            })
        }
        await updateBasket({
            parameters: {basketId: basket?.basketId},
            body: {
                c_paypalOrderID: resp?.id,
                c_paypalOrderAuthorizedID: authResponse?.id
            }
        })

        if (isExpressPaypal) {
            const paypalShippingAddress = purchaseUnits?.shipping?.address
            const [firstName, lastName] = purchaseUnits?.shipping?.name?.full_name?.split(' ') || []
            const paypalBillingAddress = resp?.payer?.address

            await updateCustomerForBasket({
                parameters: {basketId: basket.basketId},
                body: {email: resp?.payer?.email_address}
            })

            await updateShippingAddressForShipment({
                parameters: {
                    basketId: basket.basketId,
                    shipmentId: 'me',
                    useAsBilling: false
                },
                body: {
                    address1: paypalShippingAddress?.address_line_1,
                    city: paypalShippingAddress?.admin_area_2,
                    countryCode: paypalShippingAddress?.country_code,
                    firstName: firstName,
                    lastName: lastName,
                    postalCode: paypalShippingAddress?.postal_code,
                    stateCode: paypalShippingAddress?.admin_area_1
                }
            })

            await createPaymentInstrument({
                basket,
                authResponse,
                paypalPaymentInstrument,
                addPaymentInstrumentToBasket
            })

            await updateBillingAddressForBasket({
                body: {
                    address1:
                        paypalBillingAddress?.address_line_1 ||
                        paypalShippingAddress?.address_line_1,
                    city: paypalBillingAddress?.admin_area_2 || paypalShippingAddress?.admin_area_2,
                    countryCode:
                        paypalBillingAddress?.country_code || paypalShippingAddress?.country_code,
                    firstName: resp?.payer?.name?.given_name || '',
                    lastName: resp?.payer?.name?.surname || '',
                    phone: resp?.payer?.phone?.phone_number?.national_number || '',
                    postalCode:
                        paypalBillingAddress?.postal_code || paypalShippingAddress?.postal_code,
                    stateCode:
                        paypalBillingAddress?.admin_area_1 || paypalShippingAddress?.admin_area_1
                },
                parameters: {basketId: basket.basketId}
            })
            navigate('/checkout?step=review_order')
        } else {
            await createPaymentInstrument({
                basket,
                authResponse,
                paypalPaymentInstrument,
                addPaymentInstrumentToBasket
            })

            const updatedBasket = await onBillingSubmit()

            if (updatedBasket) {
                navigate('/checkout?step=review_order')
            }
        }
    } catch (error) {
        setPaypalButtonClicked && setPaypalButtonClicked(false)
        throw new Error('An unexpected error occurred', error)
    }
}

export {paypalPaymentSubmit}
